import { Locale, withLocale } from '@/locales'
import AppFooterIcon from 'Comps/svg/AppFooterIcon'
import { MobileFooterTag } from 'Types/common'
import LifecycleLink from '@/components/common/LifecycleLink'
import { useGetHomeRoute } from 'Hooks/useGetHomeRoute'
import { ComponentProps } from 'react'
import { twMerge } from 'tailwind-merge'
import { useQuickTracking } from '@/provider/QuickTrackingProvider'
type Props = {
  lang: Locale
  active: boolean
  handleOpen: () => void
  userId?: string
}
export default function AppFooterTabProfile({
  lang,
  active,
  handleOpen,
  userId,
}: Props) {
  const { trackEvent } = useQuickTracking()
  if (!userId) {
    return (
      <AppFooterTabProfileNonLoggedIn
        onClick={(e) => {
          e.preventDefault()
          handleOpen()
        }}
      />
    )
  }
  return (
    <LifecycleLink
      href={withLocale(`/profile/${userId}`, lang)}
      onClick={(e) => {
        if (!userId) {
          e.preventDefault()
          handleOpen()
        }
        trackEvent(
          'page_exposure',
          { page_name: 'profile', platform: 'web_h5' },
          'EXP'
        )
      }}
      prefetch
      replace
      className="flex h-full grow items-center justify-center"
    >
      <AppFooterIcon type={MobileFooterTag.Profile} active={active} />
    </LifecycleLink>
  )
}

export function AppFooterTabProfileNonLoggedIn({
  className,
  ...props
}: ComponentProps<'button'>) {
  const { currentBaseRoute } = useGetHomeRoute()
  return (
    <button
      className={twMerge(
        'flex h-full grow items-center justify-center',
        className
      )}
      {...props}
    >
      <AppFooterIcon
        type={MobileFooterTag.Profile}
        active={currentBaseRoute === MobileFooterTag.Profile}
      />
    </button>
  )
}
